import React, { useEffect, useState } from "react";

const initialsOf = (name) =>
  (name || "?").split(" ").map((s) => s[0]).filter(Boolean).join("").slice(0, 2).toUpperCase();

// Round photo with an initials fallback (also used when the image fails to load).
export const Avatar = ({ src, name, size = 40, className = "", fontSize, initials, testId }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const style = { width: size, height: size, fontSize: fontSize || Math.round(size * 0.36), lineHeight: 1 };
  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name ? `${name} photo` : ""}
        data-testid={testId}
        onError={() => setFailed(true)}
        className={`rounded-full object-cover shrink-0 bg-brand-light-green ${className}`}
        style={style}
        loading="lazy"
      />
    );
  }
  return (
    <span
      data-testid={testId}
      aria-hidden="true"
      className={`rounded-full bg-[#4A7C59] text-white font-heading font-bold flex items-center justify-center shrink-0 ${className}`}
      style={style}
    >
      {initials || initialsOf(name)}
    </span>
  );
};
